export default __webpack_public_path__ + "static/home-jumbotron-5b19e772ecdfeff40ca1c5d7f7c84297.jpg";